import React from "react";
import { GoogleLogin } from "@react-oauth/google";
import { Button } from "../ui/Button";
import Icon from "../AppIcon";

const GoogleLoginButton = ({ onGoogleLogin, onError }) => {
  const handleGoogleLogin = async (response) => {
    try {
      // Send Google credential to backend for verification and JWT generation
      const res = await fetch(
        "https://expenseloop.ddns.net/api/expense-loop/auth/google",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ credential: response.credential }),
          credentials: "include", // Include cookies if using session-based auth
        }
      );

      const data = await res.json();
      if (res.ok && data.success) {
        // Call the parent callback with the JWT token and user data
        onGoogleLogin(data.data.user, data.data.token);
      } else {
        console.error("Google login failed:", data.message);
        if (onError) onError(data.message || "Google login failed");
      }
    } catch (error) {
      console.error("Google login error:", error);
      if (onError)
        onError(error.message || "An error occurred during Google login");
    }
  };

  return (
    <GoogleLogin
      flow="auth-code"
      onSuccess={handleGoogleLogin}
      onError={() => {
        console.error("Google login failed");
        if (onError) onError("Google login failed");
      }}
      text="signin_with"
      shape="rectangular"
      theme="outline"
      size="large"
      logo_alignment="left"
    />
  );
};

export default GoogleLoginButton;
